import { canUseDom } from '@actr/utilities/src/dom';
import { getChannelCode, getChannelToken } from '@actr/utilities/src/url/channel-data';

/** Дополняет бэковую ссылку channelCode по тем же правилам, что и обычный
 * поиск в ak-v2 (см. getChannelCode). Вызывается прямо в рендере компонента —
 * проверено, что расхождение с SSR-версией href не приводит
 * к ошибкам гидратации (React просто патчит атрибут на клиентское значение). */
export function appendChannelToUrl(url: string): string {
  if (!canUseDom || !url) {
    return url;
  }

  let parsed: URL;
  try {
    parsed = new URL(url, window.location.origin);
  } catch {
    return url;
  }

  const channelCode = getChannelCode();
  const channelToken = getChannelToken();

  if (channelCode) {
    parsed.searchParams.set('channelCode', channelCode.toUpperCase());
  }
  if (channelToken) {
    parsed.searchParams.set('channel_token', channelToken);
  }

  return parsed.toString();
}
